"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = void 0;
exports.isObject = (value) => typeof value === "object";
//# sourceMappingURL=is-object.js.map